var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCardiologist = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 26 26",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7.313 14.422H3.25a.61.61 0 1 1 0-1.219h3.736l1.444-2.166a.61.61 0 0 1 1.015 0l2.742 4.114 1.118-1.677a.61.61 0 0 1 .508-.27h2.437a.61.61 0 0 1 0 1.218h-2.111l-1.444 2.166a.61.61 0 0 1-1.015 0l-2.742-4.114L7.82 14.15a.61.61 0 0 1-.508.27M18.078 4.266c-2.133 0-3.987.961-5.078 2.573-1.09-1.612-2.945-2.573-5.078-2.573a6.1 6.1 0 0 0-6.094 6.093v.223a.61.61 0 1 0 1.219-.039v-.184a4.88 4.88 0 0 1 4.875-4.875c2.06 0 3.79 1.1 4.514 2.872a.61.61 0 0 0 1.128 0c.725-1.772 2.454-2.872 4.514-2.872a4.88 4.88 0 0 1 4.875 4.875c0 5.66-8.288 10.73-9.953 11.691-1-.575-4.376-2.622-6.922-5.399a.61.61 0 1 0-.898.823c3.142 3.43 7.354 5.717 7.532 5.812a.61.61 0 0 0 .576 0 34 34 0 0 0 5.39-3.758c3.645-3.116 5.494-6.203 5.494-9.169a6.1 6.1 0 0 0-6.094-6.093"
})));
export { SvgCardiologist as ReactComponent };
export default __webpack_public_path__ + "assets/images/cardiologist.svg";